import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Orb from "./Orb";
import { useTranslation, Trans } from "react-i18next";

// Hero slide data
const contentData = [
  {
    key: "key-value-innovation",
    color: "#6480C0",
    image: "../assets/images/box blue.svg",
  },
  {
    key: "key-value-education",
    color: "#F38F8F",
    image: "../assets/images/box red.svg",
  },
  {
    key: "key-value-commitment",
    color: "#A7D169",
    image: "../assets/images/box green.svg",
  },
];

const HomeWhyUs = () => {
  const { t } = useTranslation();
  return (
    <section className="home-why-us">
      <Orb color="rgb(167, 209, 105)" top="66%" left="-60vh" />
      <Orb color="rgb(252, 189, 18)" bottom="50vh" right="-50vh" />

      <Container>
        <Row className="padding-content">
          {contentData.map((item, index) => {
            const image = <img src={item.image} alt={item.title} style={index % 2 === 1 ? { float: "right" } : {}} />;
            const desc = (
              <React.Fragment>
                <div className="value-title">VALUE CHILDREAMS</div>
                <h2 className="mb-4 section-title" style={{ color: item.color }}>
                  {t(`${item.key}.title`)}
                </h2>
                <Trans
                  i18nKey={`${item.key}.desc`}
                  components={{
                    p: <p />,
                  }}
                />
              </React.Fragment>
            );

            return (
              <React.Fragment key={index}>
                <Col md={index % 2 === 0 ? 3 : 9} lg={6} className="why-us-item d-none d-md-block">
                  {index % 2 === 0 ? image : desc}
                </Col>
                <Col md={index % 2 === 0 ? 9 : 3} lg={6} className="why-us-item d-none d-md-block">
                  {index % 2 === 0 ? desc : image}
                </Col>
                <Col xs={12} className="why-us-item d-block d-md-none">
                  {image}
                </Col>
                <Col xs={12} className="why-us-item d-block d-md-none">
                  {desc}
                </Col>
              </React.Fragment>
            );
          })}
        </Row>
      </Container>
    </section>
  );
};

export default HomeWhyUs;
